import React, { useState } from 'react';
import { Checkbox, Modal } from 'antd';

import './InputCheckbox.scss';

export const InputCheckbox = props => {
  const {
    title,
    defaultValue = false,
    onChange,
    warningText = '',
    dialogMessage,
    width,
  } = props;

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [checkboxValue, setCheckboxValue] = useState(defaultValue);

  const onCheckboxChange = () => {
    if (dialogMessage && !checkboxValue) {
      showDialog();
    } else {
      onChange(!checkboxValue);
      setCheckboxValue(prev => !prev);
    }
  };

  const showDialog = () => {
    setIsDialogOpen(true);
  };

  const handleOk = () => {
    onChange(!checkboxValue);
    setCheckboxValue(prev => !prev);
    setIsDialogOpen(false);
  };

  const handleCancel = () => {
    setIsDialogOpen(false);
  };

  return (
    <div className="checkbox-wrapper" style={{ width: width }}>
      <label className="checkbox-title">{title}</label>
      <Checkbox onChange={onCheckboxChange} checked={checkboxValue} />
      {warningText ? (
        <label className="checkbox-warning-text">* {warningText}</label>
      ) : null}
      {isDialogOpen ? (
        <Modal
          title="Warning"
          open={isDialogOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          className="checkbox-dialog"
        >
          <p className="checkbox-dialog-text">{dialogMessage}</p>
        </Modal>
      ) : null}
    </div>
  );
};
